































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierOutboundDocument } from '@/store/models/IDossierOutboundDocument';

@Component({ components: { Snackbar } })
export default class DossierOutboundsDocuments extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  documents: IDossierOutboundDocument[] = [];
  loadingDocuments = false;

  async mounted() {
      await this.loadOutboundDocuments();
  }

  async loadOutboundDocuments() {
      if (!this.inboundCode) return;
      this.loadingDocuments = true;

      try {
          const data = await this.dossierApi.DossierReadOutboundsDocuments(this.inboundCode);
          this.documents = data;
      } catch (err) {
          console.error('❌ Error loading Outbound Documents:', err);
      } finally {
          this.loadingDocuments = false;
      }
  }

  formatDate(dateStr: string): string {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }

  documentHeaders = [
      { text: 'Document Type', value: 'custompapername' },
      { text: 'Description', value: 'description' },
      { text: 'Actions', value: 'actions', sortable: false }
  ];
}
